/**
 * Three-dot typing indicator. The animation lives entirely in CSS
 * (keyframes defined in `styles.css`) so we don't ship a JS animation
 * runtime to render an idle placeholder.
 */
export function TypingIndicator() {
  return (
    <div
      className="ometrics-typing inline-flex items-center gap-1"
      role="status"
      aria-label="Assistant is typing"
    >
      <span className="ometrics-typing-dot" />
      <span className="ometrics-typing-dot" />
      <span className="ometrics-typing-dot" />
    </div>
  )
}
